// Textos do desenho em perspectiva do HubVerticalFarm, coletados por glob em core/i18n/messages.ts.
const pt = {
  'farm.perspectiva.cultura.soja': 'Soja',
  'farm.perspectiva.cultura.milho': 'Milho',
  'farm.perspectiva.cultura.algodao': 'Algodão',
  'farm.perspectiva.cultura.feijao': 'Feijão',
  'farm.perspectiva.cultura.sorgo': 'Sorgo',
  'farm.perspectiva.cultura.preparo': 'Em preparo',
  'farm.perspectiva.cultura.pastagem': 'Pastagem',
  'farm.perspectiva.cultura.eucalipto': 'Eucalipto',
  'farm.perspectiva.cultura.pousio': 'Pousio',

  'farm.perspectiva.tipo.pivo': 'Pivô',
  'farm.perspectiva.tipo.talhao': 'Talhão',
  'farm.perspectiva.tipo.curral': 'Curral',
  'farm.perspectiva.tipo.sede': 'Sede',
  'farm.perspectiva.tipo.reserva_legal': 'Reserva legal',
  'farm.perspectiva.tipo.app': 'APP',
  'farm.perspectiva.tipo.eucalipto': 'Eucalipto',
  'farm.perspectiva.tipo.forno': 'Fornos',
  'farm.perspectiva.tipo.lago': 'Lago',
  'farm.perspectiva.tipo.pastagem': 'Pastagem',
  'farm.perspectiva.tipo.outro': 'Outra área',

  'farm.perspectiva.marca.agri8': 'Agri8',
  'farm.perspectiva.marca.segredo': 'Segredo',
  'farm.perspectiva.marca.nenhuma': 'Sem marca',

  'farm.perspectiva.safra': 'Safra atual',
  'farm.perspectiva.norte': 'N',
  'farm.perspectiva.totalDoImovel': '{{ha}} no total',
  'farm.perspectiva.rotuloDiorama': '{{nome}} em perspectiva',
  'farm.perspectiva.rotuloGrupo': 'Os imóveis do grupo em perspectiva',
  'farm.perspectiva.rotuloCamadas': 'As cinco camadas de {{nome}}',
  'farm.perspectiva.rotuloConfinamento': 'Os currais do confinamento',
  'farm.perspectiva.idade': '{{meses}} meses',
  'farm.perspectiva.idadeAnos': '{{anos}} anos',

  'farm.perspectiva.camada': 'Camada {{n}}',
  'farm.perspectiva.camada.matriculas': 'Matrículas e CAR',
  'farm.perspectiva.camada.matriculas.modulo': 'Imóveis',
  'farm.perspectiva.camada.matriculas.desc': 'O perímetro de cada matrícula e o do CAR, com cartório e área',
  'farm.perspectiva.camada.protecao': 'Reserva legal e APP',
  'farm.perspectiva.camada.protecao.modulo': 'Mapa',
  'farm.perspectiva.camada.protecao.desc': 'O que o CAR protege: a reserva averbada, a água e a faixa de APP',
  'farm.perspectiva.camada.glebas': 'Pivôs e talhões',
  'farm.perspectiva.camada.glebas.modulo': 'Mapa',
  'farm.perspectiva.camada.glebas.desc': 'Cada gleba com nome, tipo e área calculada do polígono',
  'farm.perspectiva.camada.safra': 'Safra atual',
  'farm.perspectiva.camada.safra.modulo': 'Lavoura',
  'farm.perspectiva.camada.safra.desc': 'A cultura de cada gleba, do plantio à colheita',
  'farm.perspectiva.camada.agenda': 'Agenda e documentos',
  'farm.perspectiva.camada.agenda.modulo': 'Agenda',
  'farm.perspectiva.camada.agenda.desc': 'Vencimentos e contratos presos ao lugar a que se referem',
  'farm.perspectiva.matricula': 'Matrícula {{numero}}',
  'farm.perspectiva.reservaHa': 'Reserva legal, {{ha}}',
  'farm.perspectiva.appMargem': 'APP de 30 m em cada margem',

  'farm.perspectiva.ocupacao': 'Ocupação hoje',
  'farm.perspectiva.vazio': 'Vazio',
  'farm.perspectiva.curraisCabecas': '{{currais}} currais, {{cabecas}} cabeças',
  'farm.perspectiva.curraisLivres': '{{currais}} currais livres',
  'farm.perspectiva.curral': 'Curral {{numero}}',
  'farm.perspectiva.curralVazio': 'Curral {{numero}}, vazio',
  'farm.perspectiva.curralOcupado': 'Curral {{numero}}, {{cliente}}, {{cabecas}} cabeças',
  'farm.perspectiva.cabecas': '{{cabecas}} cabeças',
}

export default { pt }
